import React, { FC } from 'react'

interface Props {
  clickCallback: (url: string) => void
  list: {
    url: string
    title: string
    text: string
    image?: string
  }[]
}

const CardList: FC<Props> = (props) => {
  const {
    clickCallback,
    list,
  } = props

  return (
    <div className="card_frame">
      {
        list.map((value, i) => (
          <div
            className="card"
            key={`list_${i + 0}`}
            onClick={() => clickCallback(value.url)}
            role="none"
          >
            <div className="detail_area">
              <div className="title">
                {value.title}
              </div>
              <div className="text">
                {value.text}
              </div>
            </div>
            <div className="image_area">
              <img src={value.image} alt="" />
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default CardList
